export enum PaymentPlanAction {
  CANCEL_PAYMENT_PLAN = 'cancel_payment_plan',
}
